import React from "react";
import { Modal } from "flowbite-react";

const  StaticPopup = ({
  openModal,
  handleClose,
  header,
  headerSub,
  children,
  height = 60,
  width = "xl",
  size = "lg",
  headerLogo,
  bodyStyle = "px-6 pb-8 pt-3",
  headerSize = "text-sm",
  zIndex = 50,
}) => {
  return (
    <div>
      <Modal
        style={{ zIndex }}
        dismissible
        show={openModal}
        onClose={handleClose}
        size={width}
      >
        <div
          className={`flex justify-between ${
            size === "sm" ? "pl-5" : "pl-5"
          } pr-4 py-2 items-center border-b-[1px] border-gray-200`}
        >
          <div className="flex gap-3 items-center text-sm">
            {headerLogo && (
              <div className="max-h-6">
                {/* <div dangerouslySetInnerHTML={{ __html: headerLogo }} /> */}
                {headerLogo}
              </div>
            )}
            <p className={`font-bold ${headerSize} text-[#3F4B64]`}>
              {header}
              {headerSub && (
                <span className="text-sm font-extralight ml-1 italic">
                  {`( ${headerSub} )`}
                </span>
              )}
            </p>
          </div>
          <button
            className="hover:bg-slate-100 text-sm text-[#5B6882] flex gap-2 items-center px-2  rounded-lg"
            onClick={handleClose}
          >
            Close
            <svg
              width="8"
              height="8"
              viewBox="0 0 12 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1 1L11 11M11 1L1 11"
                stroke="#232E9B"
                stroke-linecap="round"
              />
            </svg>
          </button>
        </div>
        <div
          className={`flex flex-col gap-6 overflow-auto text-sm ${bodyStyle}`}
          style={{ minHeight: height }}
        >
          {children}
        </div>
      </Modal>
    </div>
  );
};

export default StaticPopup;
